<script setup lang="ts">

import HealthMonitoring from '@presentation/Icons/HealthMonitoring.vue';

</script>

<template>

    <Page>

        <ImageAndText 
            src="/WhatIsCarbucks/health-monitoring.png"
            image-class="max-w-[300px] drop-shadow-xl"
            animation="slide-up"
            floor-shadow>

            <Animated :delay="500" :duration="500" animation="slide-left">
                <HealthMonitoring />
            </Animated>

            <h2 class="my-4">24/7 Health Monitoring</h2>
            <p class="font-normal text-white/80">
                Seamlessly integrates wellness insights into your driving journey. 
                Real-time diagnostics, personalised suggestions, and safety 
                enhancements redefine your drive. Experience innovation with CarBucks.
            </p>

        </ImageAndText>

    </Page>

</template>